import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect} from 'react-router-dom'
import {StripeProvider} from 'react-stripe-elements';
import {Elements} from 'react-stripe-elements';
import './App.css';
import Home from './Components/Modules/LoginSignup/Home'
import TeamStep from './Components/Modules/LoginSignup/TeamStep'
import IntergrationInformation from './Components/Modules/LoginSignup/IntergrationInformation'
import Not_Found from './Components/Pages/404'
import Login from './Components/Modules/LoginSignup/Login'
import ForgotPassword from './Components/Modules/LoginSignup/ForgotPassword'
import Dashboard from './Components/Pages/Dashboard'
import AudioVisual from './Components/Pages/AudioVisual'
import ChangePassword from './Components/Pages/ChangePassword'
import EditProfile from './Components/Pages/EditProfile'
import AdminDashboard from './Components/Pages/Admin/AdminDashboard'
import AdminCompany from './Components/Pages/Admin/AdminCompany'
import AdminJobDetail from './Components/Pages/Admin/AdminJobDetail'
import AdminAudioVisual from './Components/Pages/Admin/AdminAudioVisual'
import AdminTemplate from './Components/Pages/Admin/AdminTemplate'
import AdminLogs from './Components/Pages/Admin/AdminLogs'
import Company from './Components/Pages/Company'
import Job from './Components/Pages/Job'
import UserAccount from './Components/Pages/UserAccount'
import Templete from './Components/Pages/Templete'
import TempleteSet from './Components/Pages/TempleteSet'
import ThankYou from './Components/Pages/ThankYou'
import SubscriptionPlan from './Components/Pages/SubscriptionPlan'
import Unsubscribe from './Components/Pages/Unsubscribe'
import TermsService from './Components/Pages/TermsService'
import PrivacyPolicy from './Components/Pages/PrivacyPolicy'

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import {grey800  ,blue100 , black, white  ,blue500} from 'material-ui/styles/colors'

import { connect } from 'react-redux';
import * as actions from './Actions/index.js';
import { AlertList } from "react-bs-notifier";
import _ from 'lodash';

import env from './config/env.js'

const stripePublishableKey=env.stripePublishableKey;

const muiTheme = getMuiTheme({
  fontFamily: 'Heebo, sans-serif',
    palette: {
      primary2Color: blue100,
      primary1Color: blue500,
      accent2Color:black,
      accent1Color:blue500,
      alternateTextColor:blue500,
      textColor:grey800,
      canvasColor:white,
      pickerHeaderColor:blue100,
      
    },
})

class App extends React.Component {
  constructor(props) {
      super(props);
      this.state={
        alerts: []
      };
      this.toastsDisplayed = [];
  }
  //check is user is login or not
  isLoggedIn() {
    var token = window.localStorage.getItem('agl-token');
    return !!token;
  }
  // check if user type is normal or admin user
  isAdminType(){
    var usertype = window.localStorage.getItem('userType');
    if(usertype==='3'){
      return true;
    }else{
      return false;
    }
  }
  // fetch importent data for current login user
  componentDidMount(){
    if(window.localStorage.getItem('agl-token')){
      this.props.fetchLoginUserDetail();
      this.props.fetchAllSubscriptions();
      this.props.getLoggedInUser();
    }
  }
  componentWillMount(){
    /*let token = window.localStorage.getItem('agl-token');
    if(token){
      this.props.getLoggedInUser();
    }*/
  }
  render() {
    var usertype = window.localStorage.getItem('userType');
    if( _.has(this.props.notifications, 'items') ) {
      const notification = _.find(this.props.notifications.items, (n) => {
        return _.indexOf(this.toastsDisplayed, n.id) === -1;
      });
      if( notification ) {
        this.toastsDisplayed.push(notification.id);
          let alerts = [{
            id: notification.id,
            type: notification.type,
            message: notification.text
        }]
        this.setState({alerts:alerts});
      }
    }
    // routing of component based on admin/normal user 
    let user = this.props.login.loggedInUser;
    
    return ( <div>
              { <AlertList alerts={this.state.alerts} timeout={4000} dismissTitle="close" showIcon={true} onDismiss={()=>this.setState({alerts: []})} /> }
                <MuiThemeProvider muiTheme={muiTheme}>
                    <Router>
                        <Switch>
                        {user && user.type==3 && usertype==3 ?
                            <div>
                                <Switch>
                                  <Route  path="/admin-dashboard" component={AdminDashboard} />
                                  <Route  path="/admin-company" component={AdminCompany} />
                                  <Route  path="/admin-job" component={AdminJobDetail} />
                                  <Route  path="/jobmaual" component={AdminAudioVisual}/>
                                  <Route  path="/admin-template" component={AdminTemplate}/>
                                  <Route  path="/admin-logs" component={AdminLogs}/>
                                   <Route exact path="/" component={AdminDashboard} />
                                   <Route exact path="/login" render={() => ( <Redirect to="/admin-dashboard" /> )} />
                                   <Route component={Not_Found} /> 
                                </Switch>
                            </div> :

                            <div>
                                <Switch>
                                <Route  path="/unsubscribe" component={Unsubscribe} />
                                    {/* first check is it login and if it is login send to job page. */}
                                    {this.isLoggedIn() ? 
                                        <Route path="/job" component={()=> <Job userdetail={this.props.currentuser}/>} />
                                    : null }
                                    
                                    {this.props.signUp.payment!==null?<Route exact path="/signup" render={() => ( <Redirect to="/team-setup" /> )} />:""}
                                     
                                    {this.props.signUp.team!==null?<Route exact path="/team-setup" render={() => ( <Redirect to="/intergration-information" /> )} />:""}
                                     
                                    {this.props.signUp.simproApi===true?<Route exact path="/intergration-information" render={() => ( <Redirect to="/job" /> )} />:""}
                         
                                    {!this.isLoggedIn()?
                                        <Switch>
                                            <Route exact path="/login" component={Login} />
                                            <Route path="/signup" component={Home} />
                                            <Route path="/team-setup" component={TeamStep} />
                                            <Route path="/intergration-information" component={IntergrationInformation} />
                                            <Route path="/forgot-password" component={ForgotPassword} />
                                            <Route path="/thankyou" component={ThankYou} />
                                            <Route path="/" render={() => ( <Redirect to="/login" /> )} />
                                        </Switch>
                                    : null}

                                    {this.isLoggedIn() ?
                                        <div>
                                            <Switch>
                                                {user && user.type !=3 && usertype !=3 &&
                                                      <Route exact path="/login" render={() => ( <Redirect to="/job" /> )} />
                                                }
                                                
                                                {user && user.type !=3 && usertype !=3 &&
                                                    <Route exact path="/" render={() => ( <Redirect to="/job" /> )} /> }
                                                
                                                <Route  path="/audio-visual" component={AudioVisual} />
                                                <Route  path="/change-password" component={ChangePassword} />
                                                <Route  path="/edit-profile" component={EditProfile} />
                                                <Route  path="/company" component={Company} />
                                                <Route  path="/job" component={()=> <Job userdetail={this.props.currentuser}/>} />
                                                <Route  path="/user-account" component={()=> <UserAccount userdetail={this.props.currentuser}/>} />
                                                {/*<Route  path="/templete" component={()=> <Templete userdetail={this.props.currentuser}/>} />*/}

                             

                                                <Route  path="/template" component={()=> <TempleteSet userdetail={this.props.currentuser}/>} />
                                                <StripeProvider apiKey={stripePublishableKey}>
                                                <Elements>
                                                <Route  path="/subscription-plan" component={SubscriptionPlan} />
                                                </Elements>
                                                </StripeProvider>
                                                
                                                <Route  path="/unsubscribe" component={Unsubscribe} />
                                                
                                                <Route  path="/terms-service" component={TermsService} />
                                                
                                                <Route  path="/privacy-policy" component={PrivacyPolicy} />
                                                 
                                                <Route path="/signup" render={() => ( <Redirect to="/job" /> )} />
                                                {user && user.type !=3 && usertype !=3 &&
                                                     <Route component={Not_Found} /> 
                                                 }
                                            </Switch>
                                        </div> : 

                                        <Redirect to="/login" /> }
                                </Switch>
                           </div>
                        }
                        </Switch>
                    </Router>  
                </MuiThemeProvider>           
              </div>
    );
  }
}
const mapStateToProps= (state,props)=> {
    return {
      signUp : state.signup,
      currentuser : state.login,
      notifications: state.notifications,
      subscriptionPlan: state.subscription,
      login: state.login
    }; 
}

export default connect(mapStateToProps,actions)(App);



// WEBPACK FOOTER //
// ./src/App.js